const liveBroadRoom = {
  // 推荐直播
  recommendLiveList: `/liveApi/api/v1/Live/pcRecommendLiveList`,
  // 获取拉流地址
  getPullUrl: `/liveApi/api/v1/Live/getPullUrl`,
  // 直播列表
  liveList: `/liveApi/api/v1/Live/liveList`,
  // 直播首页推荐直播列表 -- 刘阳 -- 张志国
  pcRecommendLive: `/liveApi/api/v6/Home/pcRecommendLive`,
  // 直播首页推荐直播列表 -- 张志国
  pcRecommendLiveV5: `/liveApi/api/v6/Home/pcRecommendLive`,
  // 检查直播状态 -- 张志国
  checkLive: `/liveApi/api/v5/Home/checkLive`,
  // v3全部直播列表 -- 刘阳
  // pcAllLive: `/liveApi/api/v3/Home/pcAllLive`,
  pcAllLive: `/liveApi/api/v6/Home/liveList`,
  // 礼物列表
  giftList: `/liveApi/api/v2/Gift/giftList`,
  // 礼物背包列表
  backpackList: `/liveApi/api/v2/Gift/backpackList`,
  // 礼物消耗记录
  consumeItemRecord: `/liveApi/api/v2/Gift/consumeItemRecord`,
  // 礼物获得记录
  incomeItemRecord: `/liveApi/api/v2/Gift/incomeItemRecord`,
  //  主播中心设置
  anchorCenter: `/liveApi/api/v2/User/anchorCenter`,
  //  主播中心设置保存
  anchorCenterSave: `/liveApi/api/v2/User/anchorCenterSave`,
  //  开始直播
  beginLive: `/liveApi/api/v1/Live/beginLive`,
  //  结束直播
  endLive: `/liveApi/api/v1/Live/endLive`,
  //  直播记录
  liveRecord: `/liveApi/api/v1/Live/liveRecord`,
  //  获取推流地址（CDN推拉流）
  getPushKey: `/liveApi/api/v1/Live/getPushKey`,
  // //  直播间详情
  // liveDetail: `/liveApi/api/v1/Live/liveDetail`,
  // //  观众进入直播间
  // enterLiveRoom: `/liveApi/api/v1/Live/enterLiveRoom`,
  // //  观众退出直播间
  // quitLiveRoom: `/liveApi/api/v1/Live/quitLiveRoom`,
  //  直播间详情
  liveDetail: `/liveApi/api/v3/Room/detail`,
  //  观众进入直播间
  enterLiveRoom: `/liveApi/api/v3/Room/enterRoom`,
  //  观众退出直播间
  quitLiveRoom: `/liveApi/api/v3/Room/quitRoom`,
  //  文本消息-发送文本消息
  sendTextMessage: `/liveApi/api/v2/Message/sendTextMessage`,
  //  赠送礼物
  giveGift: `/liveApi/api/v2/Gift/give`,
  //  赠送礼物（麦序直播）
  voiceGiveGift: `/liveApi/api/v4/Gift/give`,
  //  关闭推流地址显示(CDN推拉流)
  closePushUrl: `/liveApi/api/v1/Live/closePushUrl`,
  // 关注列表
  followList: `/liveApi/api/v2/user/followList`,
  //  结束界面直播推荐(CDN推拉流)
  recommendLive: `/liveApi/api/v6/Live/recommendLive`,
  //  主播中心标题保存
  anchorCenterSaveTitle: `/liveApi/api/v2/User/anchorCenterSaveTitle`,
  //  直播间游戏信息
  gameInfo: `/liveApi/api/v3/Room/gameInfo`,
  //  获取展示直播导游戏 开关 --- 刘琪
  guideGameSwitch: `/liveApi/api/v3/Anchor/guideGameSwitch`,
  // 活动入口列表
  // activityList: `/liveApi/api/v3/Room/activityList` https://test-api.996box.com/tip/v1/floatPopupList{
  activityList: `/authApi/tip/v1/floatPopupList`,
  //  直播间活动入口列表
  roomEntranceList: `/authApi/show/activityPromotionEntranceList`,
  //  判断 是否展示游戏社区展示 该按钮
  isShowGameCom: `/liveApi/api/v2/User/isShowGameCom`,
  //  判断 是否展示游戏社区展示 该按钮
  isShowServer: `/liveApi/api/v2/User/isShowServer`,
  // 获取连麦token（v6 通配 RTC token，可加入多个频道）
  getLmToken: `/liveApi/api/v6/Anchor/getLmToken`,
  // 预加载资源（礼物、水印等）
  preloadingResource: `/liveApi/api/v1/Config/preloadingResource`,
  // 举报类型列表（免登录）
  reportTypeList: `/liveApi/api/v1/LiveReport/typeList`,
  // 提交举报（需登录 + 签名）
  submitLiveReport: `/liveApi/api/v1/LiveReport/submit`,
  // 直播间进入协议确认弹窗配置（免登录）
  liveAgreementConfig: `/liveApi/api/v1/config/liveAgreementConfig`
};

export default liveBroadRoom;
